<template>
  <div>
    <div v-if="(illustrated_bones.indexOf(bone.id) > -1) && !hideSVG" class="dcf-float-right dcf-ml-2 dcf-mr-2" style="width: 400px;">
      <svg viewBox="0 0 712 342">
        <use href="#illustration_outline" fill="#CCCCCC" />
        <use href="#bone_fill" fill="#FFFFFF" />
        <use :href="'#bone_' + bone.id" fill="#FF0000" />
        <use href="#bone_outlines" />
      </svg>
    </div>
    <h2>{{ bone.name }}</h2>
    
    <dl>
      <template v-if="bone.common_name">
        <dt>Common Name</dt>
        <dd>{{ bone.common_name }}</dd>
      </template>

      <template v-if="bone.skeletal_division">
        <dt>Skeletal Division</dt>
        <dd>{{ bone.skeletal_division }}</dd>
      </template>

      <template v-if="bone.description">
        <dt>Description</dt>
        <dd>{{ bone.description }}</dd>
      </template>

      <template v-if="bone.location">
        <dt>Location</dt>
        <dd>{{ bone.location }}</dd>
      </template>

      <template v-if="bone.articulation">
        <dt>Articulation</dt>
        <dd>{{ bone.articulation }}</dd>
      </template>

      <template v-if="bone.number">
        <dt>Number</dt>
        <dd>{{ bone.number }}</dd>
      </template>
    </dl>
    
  </div>
</template>

<script>

export default {
  props: ['bone','hideSVG' ],
  data: function(){
    return {
      illustrated_bones: null 
    }
  },
  created: function(){
    this.illustrated_bones = window.illustrated_bones;
  }
}

</script>

